import { Roles } from "~/roleModel";

/** Кластеры ролей для проверок */
export const IsHoldingDealerRoleCluster = [Roles.dealer, Roles.holding];
export const IsAdminRoleCluster = [Roles.adminData, Roles.admin];
export const IsRegMenRoleCluster = [
  Roles.leaderRegionalSalesManager,
  Roles.leaderRegionalServiceManager,
  Roles.regionalSalesManager,
  Roles.regionalServiceManager,
];
export const IsDealerRoleCluster = [Roles.dealer];
//... продолжи добавлять тут
/** --- */
